import React from 'react';
import { productMargin, marginTone } from '@/lib/costMargin';

const money = (v) => `£${Number(v).toFixed(2)}`;

// Cost price and margin, shown directly under a product's selling price so the
// two read together. A product with no cost recorded says so rather than
// implying a 100% margin.
export default function ProductMarginLine({ product }) {
  const { cost, margin, marginPct, hasCost } = productMargin(product);

  if (!hasCost) {
    return <p className="text-white/25 text-[10px] mt-0.5">No cost recorded</p>;
  }

  return (
    <p className="text-[10px] mt-0.5 whitespace-nowrap">
      <span className="text-white/40">Cost {money(cost)}</span>
      <span className="text-white/20"> · </span>
      <span className={marginTone(marginPct)}>GM {money(margin)} · {marginPct.toFixed(0)}%</span>
    </p>
  );
}